'use strict';

var qunar = require('./qunar/');
var ctrip = require('./ctrip/');

module.exports = [].concat(qunar).concat(ctrip);


//////////////////
// WEBPACK FOOTER
// ../plugins/index.js
// module id = 31
// module chunks = 1 4